<template>
  <v-app>
    <Snackbar :SnackBarComponent="SnackBarComponent"></Snackbar>
    <Overlay :overlay="overlay" />
    <v-app-bar flat color="transparent" class="px-4 pt-4">
      <v-app-bar-title>
        <!-- <h2>Eztrak</h2> -->
        <!-- <v-img
          :width="100"
          aspect-ratio="16/9"
          cover
          src="@/assets/EztrackBlackLogo.png"
        ></v-img> -->
      </v-app-bar-title>
    </v-app-bar>

    <v-main class="d-flex align-center justify-center whole-background">
      <v-container fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" md="10" lg="8">
            <v-card elevation="12" class="rounded-xl overflow-hidden">
              <v-row no-gutters>
                <v-col cols="12" md="6" class="md-and-up-only">
                  <v-card class="card-background"> </v-card>
                </v-col>

                <v-col cols="12" md="6" class="pa-8">
                  <div align="center" class="mb-2">
                    <v-img :width="157" aspect-ratio="16/9" cover src="@/assets/EztrackBlackLogo.png"></v-img>
                  </div>
                  <v-window v-model="step" class="px-1">
                    <v-window-item :value="1">
                      <h1 class="mb-1 text-center">Welcome Back!</h1>
                      <p class="fontVariant3 mb-4 text-center">
                        Enter your email to get started
                      </p>
                      <v-form ref="form" @submit.prevent="ValidateSignInForm">
                        <v-text-field color="primary" v-model="EmailID" label="Email Address*"
                          placeholder="Enter your email" variant="outlined" :rules="[
                            (v) => !!v || 'Email is required',
                            (v) =>
                              /^\S+@\S+\.\S+$/.test(v) ||
                              'Invalid email format',
                          ]" class="mb-4 fiel" required>
                          <template v-slot:prepend-inner>
                            <div align="center">
                              <v-icon color="primary">mdi-email</v-icon>
                            </div>
                          </template>
                        </v-text-field>

                        <v-btn class="fontVariant3 rounded-lg" block size="large" variant="flat" :loading="loading"
                          color="primary" type="submit" @click="ValidateSignInForm()">Send otp</v-btn>
                      </v-form>

                      <v-divider class="my-6"></v-divider>

                      <!-- <p align="center">
                        Dont' have an account ?
                        <span
                          class="cursorPointer text-primary"
                          @click="step = 3"
                          >Sign up</span
                        >
                      </p> -->
                    </v-window-item>
                    <v-window-item :value="2">
                      <div align="end">
                        <v-icon color="primary" @click="goBacktoStep01">mdi-arrow-left-bold</v-icon>
                      </div>

                      <h1 class="mb-1 text-center">Welcome Back!</h1>
                      <p class="fontVariant3 mb-4 text-center">
                        Please enter the OTP that was sent to your registered
                        EmailID:
                      </p>
                      <v-card-text class="pa-2">
                        <v-otp-input ref="otpInput" elevation="0" :length="6" v-model="otp" :loading="otpLoading"
                          @keydown.enter.prevent="validateVerifyOtpMethod()"></v-otp-input>
                        <div class="d-flex align-center mx-3 mb-2">
                          <v-btn :disabled="otp.length < 6 || otpLoading" class="fontVariant3" block variant="flat"
                            :loading="loading" color="primary" @click="validateVerifyOtpMethod()">Login</v-btn>
                        </div>

                        <div class="fontVariant3 text-center">
                          Didn't receive the OTP?
                          <span class="fontVariant3 text-primary cursorPointer"
                            @click="ValidateSignInForm">Resend</span>
                          code.
                        </div>
                      </v-card-text>
                    </v-window-item>
                  </v-window>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { signIn, signOut, confirmSignIn } from "aws-amplify/auth";
import Snackbar from "@/components/Extras/Snackbar.vue";
import Overlay from "@/components/Extras/Overlay.vue";
export default {
  components: {
    Snackbar,
    Overlay,
  },
  data() {
    return {
      step: 1,
      height: 0,
      windowHeight: 0,
      SnackBarComponent: {},
      overlay: false,
      EmailID: "",
      otp: "",
      loading: false,
      user: "",
      otpLoading: false,
      createUserAccount: {
        user_name: "",
        contact_number: "",
        country_code: "+91",
      },
      loadingUser: false,
    };
  },

  watch: {
    step(val) {
      if (val === 2) {
        this.$nextTick(() => {
          this.$refs.otpInput.focus();
        })
      }
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight - 50;
    // this.disableBrowserArrowIcons();
    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    }, 400);
  },

  methods: {
    goBacktoStep01() {
      this.otp = "";
      this.step = 1;
    },
    disableBrowserArrowIcons() {
      console.log("Domain", window.location.hostname);

      if (window.location.hostname === "localhost") {
        // Push a state to history
        history.pushState(null, null, window.location.href);

        // Add an event listener for the popstate event
        window.addEventListener("popstate", function () {
          // Push the state again to prevent navigation
          history.pushState(null, null, window.location.href);
        });

        console.log("Navigation buttons disabled on localhost:8081");
      }
    },

    goBack() {
      // this.$refs.form.reset();
      // this.$refs.formCreateAccount.reset();
      this.otp = "";
      this.step = 1;
    },
    async ValidateSignInForm() {
      this.loading = true;
      let isValid = await this.$refs.form.validate();
      if (isValid.valid) {
        console.log("isValid.valid", isValid.valid);
        await this.SignWithOtpMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
        this.loading = false;
      }
    },

    async SignWithOtpMethod() {
      console.log("called");
      try {
        console.log("this.EmailID.trim()", this.EmailID.trim());
        this.user = await signIn({
          username: this.EmailID.trim(),
          options: {
            authFlowType: "CUSTOM_WITHOUT_SRP",
          },
        });
        console.log("result of SignWithOtpMethod step-1", this.user);
        if (
          this.user.nextStep.signInStep ==
          "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        ) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: `Verification OTP sent to ${this.EmailID}`,
          };
          this.step = 2;
        }
      } catch (error) {
        console.log("error in SignWithOtpMethod step-1", error);
        if (error.message == "There is already a signed in user.") {
          await this.logoutMethod(this.EmailID);
        }
        if (
          error.message ===
          "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup."
        ) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "User Not Found",
          };
        }

        let errorMessage =
          error.message ===
          "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup." ||
          error.message == "There is already a signed in user.";
        if (!errorMessage) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: error.message,
          };
        }
      } finally {
        this.loading = false;
      }
    },

    async logoutMethod(EmailID) {
      this.loading = true;
      try {
        const user = await signOut({
          username: EmailID,
        });

        await this.ValidateSignInForm();
      } catch (error) {
        console.error("Error in logoutMethod", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async validateVerifyOtpMethod() {
      this.otpLoading = true;
      console.log("this.otp", this.otp);
      try {
        let result = await confirmSignIn({ challengeResponse: this.otp });
        console.log("result", result);
        if (result.nextStep.signInStep === "DONE") {
          this.$store.commit("SET_USER_EMAIL_ID", this.EmailID);
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Success",
          };
          this.ActivateMethod();
        }
      } catch (error) {
        // console.log("error in validateVerifyOtpMethod ", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      } finally {
        this.otpLoading = false;
      }
    },
    ActivateMethod() {
      this.otpLoading = true;
      setTimeout(() => {
        this.otpLoading = false;
        this.$router.push("/Dashboard");
      }, 500);
    },
  },
};
</script>

<style scoped>
/* Custom styles for additional polish */

.whole-background {
  background-image: url("@/assets/yellow_background.png");
  background-size: cover;
  background-position: center;
}

.card-background {
  background-image: url("@/assets/LoginPageCard.jpg");
  background-size: cover;
  background-position: center;
  min-height: 550px;
}

.md-and-up-only {
  display: none;
}

@media (min-width: 960px) {
  .md-and-up-only {
    display: block;
  }
}
</style>
